import { Select } from '@amzn/stencil-react-components/select';
import { Col, View } from '@amzn/stencil-react-components/layout';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateMetricFilter } from '../../../actions/ruleFiltersActions';
import isEmpty from 'lodash/isEmpty';
import {
  initialDataSelector,
  ruleFiltersSelector,
} from '../../../selectors/selectors';

import MetricConfig from '../../../json/metricFilterConfig.json';
import metricNames from '../../../json/metricNames.json';
import MetricValue from './MetricValue';
import { getKeyByValue } from '../../../util/commonUtils';
import { RuleFilterMetricMapping } from '../../../constants/createSegment';

import { IconCrossInsideCircleSmall } from '@amzn/stencil-react-icons';

const MetricSection = ({ metric, index }) => {
  const isDisabled = false;
  const dispatch = useDispatch();
  const { metrics } = useSelector(ruleFiltersSelector);
  const [metricName, setMetricName] = useState(metric?.metricName);
  const [metricOperator, setMetricOperator] = useState(metric?.metricOperator);
  const [metricValue, setMetricValue] = useState(metric?.metricValue);
  const { metricNamesOptions } = useSelector(initialDataSelector);
  const metricKey = getKeyByValue(RuleFilterMetricMapping, metric?.metricName);
  const [metricConfig, setMetricConfig] = useState(MetricConfig?.metricFilterConfig?.[metricKey]);

  let metricDetails = {};
  const onMetricSectionDelete = () => {
    const metricList = [...metrics];
    metricList.splice(index, 1);
    dispatch(updateMetricFilter(metricList));
  };

  const onMetricNameChange = e => {
    metricDetails = metricNames.metricNames.find(({ name }) => name === e);
    setMetricConfig(MetricConfig?.metricFilterConfig?.[metricDetails?.value]);
    setMetricName(metricDetails?.name);
    setMetricValue(null);
  };

  const onMetricOperatorChange = e => {
    setMetricOperator(e);
  };

  const onMetricValueChange = e => {
    setMetricValue(e);
  };

  useEffect(
    () => {
      if (!isEmpty(metricName) && !isEmpty(metricOperator) && !isEmpty(metricValue)) {
        const metricList = [...metrics];
        metricList[index] = {
          metricName: getKeyByValue(RuleFilterMetricMapping, metricName),
          metricOperator,
          metricValue,
        };
        dispatch(updateMetricFilter(metricList));
      }
    },
    [metricName, metricOperator, metricValue],
  );

  return (
    <>
      <View width="100%" display="flex" style={{ gap: '10px' }} alignItems="center">
        <Col width="20%">
          <Select
            data-testid="metric-name-dropdown"
            disabled={isDisabled}
            options={metricNamesOptions}
            value={metricName}
            onChange={e => onMetricNameChange(e)}
          />
        </Col>
        <Col width="20%">
          <Select
            data-testid="metric-operator-dropdown"
            disabled={isDisabled || isEmpty(metricName)}
            options={metricConfig?.operators}
            value={metricOperator}
            onChange={e => {
              onMetricOperatorChange(e);
            }}
          />
        </Col>
        <Col width="20%">
          {!isEmpty(metricConfig) ? (
            <MetricValue
              metricConfig={metricConfig}
              metricValue={metricValue}
              onChange={e => onMetricValueChange(e)}
              isDisabled={isEmpty(metricName) || isEmpty(metricOperator)}
            />
          ) : null}
        </Col>
        <Col width="5%" display="flex" justifyContent="center" alignItems="center">
          <View
            color="primary"
            data-testid="delete-icon"
            style={{ cursor: 'pointer' }}
            onClick={onMetricSectionDelete}
          >
            <IconCrossInsideCircleSmall />
          </View>
        </Col>
      </View>
    </>
  );
};

export default MetricSection;
